<template lang="pug">
div
    UniversalLink(
        :link="data.link"
        :openNewWindow="data.linkTarget === 'NEW_WINDOW'"
        trackingEventType="ImageBullet"
    )
        div(
            class="flex"
            :class="displayClasses"
        )
            div
                //- This should only ever be 1 image but it still comes in an array
                template(v-for="imageWidget in data.image")
                    slot(:data="imageWidget")

            div(class="flex-1")
                template(v-for="textWidget in data.text")
                    slot(:data="textWidget")

</template>

<script>
import UniversalLink from '@/components/universalLink'
import { getScreenClassPrefix } from '../../helpers'

export default {
    name: 'ImageBulletWidget',
    components: {
        UniversalLink,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        displayClasses() {
            return [
                getScreenClassPrefix(
                    this.getPositionClass(this.data.mobileImagePosition),
                    this.getPositionClass(this.data.tabletImagePosition),
                    this.getPositionClass(this.data.desktopImagePosition)
                ),
                { 'items-center': this.data.isVerticalAligned === 'true' },
            ]
        },
    },
    methods: {
        getPositionClass(alignment) {
            /**
             * Tailwind Flex Display Whitelist
             *
             * Because we are dynamically creating the class names to reduce the JS complexity
             * we have to list these classes out so they don't get purged during the build process
             *
             * flex-row md:flex-row lg:flex-row
             * flex-col md:flex-col lg:flex-col
             *
             */

            switch (alignment) {
                case 'LEFT':
                    return 'flex-row'

                case 'TOP':
                    return 'flex-col'

                default:
                    return ''
            }
        },
    },
}
</script>
